import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MessageContentUnion } from '@airgram/core/types/outputs';
import { MessageVoiceNote } from '@airgram/core/types/outputs/MessageContent';
import { FilePart } from '@airgram/web';
import { FileReaderService } from '@src/core/services';
import { MultimediaSource } from '@src/models';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-message-voice-note',
  templateUrl: './message-voice-note.component.html',
  styleUrls: ['../styles/message-content.scss', './message-voice-note.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageVoiceNoteComponent extends BaseResizableComponent {
  private readonly fileReaderService = inject(FileReaderService);

  @Input() set message(mess: MessageContentUnion | undefined) {
    this.messageVoiceNote = mess as MessageVoiceNote;
  }

  messageVoiceNote?: MessageVoiceNote;
  messageVoiceSource?: MultimediaSource;

  override ngOnInit(): void {
    super.ngOnInit();

    this.initVoice();
  }

  private initVoice(): void {
    if (!this.messageVoiceNote) return;

    this.fileReaderService
      .getFilePart(this.messageVoiceNote?.voiceNote?.voice)
      .pipe(takeUntil(this.destroyed$$))
      .subscribe(filePart => this.setVoiceSource(filePart));
  }

  private setVoiceSource(filePart?: FilePart): void {
    this.messageVoiceSource = { src: this.fileReaderService.getFileSource(filePart) };
    this.cdr.markForCheck();
  }
}
